import { render, staticRenderFns } from "./InformationPleat.vue?vue&type=template&id=1665043a&scoped=true&"
import script from "./InformationPleat.vue?vue&type=script&lang=js&"
export * from "./InformationPleat.vue?vue&type=script&lang=js&"
import style0 from "./InformationPleat.vue?vue&type=style&index=0&id=1665043a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665043a",
  null
  
)

export default component.exports